import React from "react";
import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Landing from "./pages/Landing";
import Pricing from "./pages/Pricing";
import PortfolioFull from "./pages/PortfolioFull";
import Personals from "./pages/Personals";
import TeamPortal from "./pages/TeamPortal";
import ClientPortal from "./pages/ClientPortal";
import Login from "./pages/Login";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/portfolio" element={<PortfolioFull />} />
        <Route path="/team/:slug" element={<Personals />} />
        <Route path="/team-portal" element={<TeamPortal />} />
        <Route path="/client-portal" element={<ClientPortal />} />
        <Route path="/login" element={<Login />} />
      </Routes>
    </Router>
  );
}

export default App;
